import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { QuotationProvider } from "presentation/store/QuotationSetting/QuotationProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { QuotationMaintenance } from "presentation/view/section/QuotationSetting/QuotationMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const QuotationContMain = () => {
    return <ANAInfoWrapper permission={Permission.QUOTATION_SETTING_MAINTENANCE}>
        <MessageBarWrapper>
            <QuotationProvider>
                <GridStyles />
                <QuotationMaintenance />
            </QuotationProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default QuotationContMain;